var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonArrowSolidOrange = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2835",
  d: "M0 0h28c15.464 0 28 12.088 28 27v2c0 14.912-12.536 27-28 27H0z",
  fill: "#f96506"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144544",
  fill: "none",
  d: "M13.001 16h24v24h-24z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.899 29.045H14.231a1.191 1.191 0 01-.877-.354 1.191 1.191 0 01-.354-.877 1.192 1.192 0 01.354-.877 1.192 1.192 0 01.877-.353h18.668L24.415 18.1a1.157 1.157 0 01-.361-.857 1.219 1.219 0 01.387-.873 1.286 1.286 0 01.865-.369 1.148 1.148 0 01.865.369l10.406 10.406a1.361 1.361 0 01.325.486 1.577 1.577 0 01.095.552 1.577 1.577 0 01-.095.552 1.361 1.361 0 01-.325.486L26.171 39.258a1.175 1.175 0 01-.844.349 1.227 1.227 0 01-.885-.349 1.206 1.206 0 01-.382-.877 1.206 1.206 0 01.382-.877z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/button-arrow-solid-orange.2756ff739fa0d34136a3e8d6002532f8.svg";
export { SvgButtonArrowSolidOrange as ReactComponent };